<template>
  <CModal :title="modalTitle"
          color="warning"
          :show="show"
          :centered="true"
          @update:show="closeModal">

    <div class="content">
      <div class="modal-title">
        <h2>Shipyard Details</h2>
        <i v-if="loading" class="fa fa-cog fa-spin fa-2x"></i>
      </div>

      <CRow v-if="shipyard">
        <CCol col="12" class="pr-3">
          <div class="details-row">
            <div class="details-row__title">Id</div>
            <div class="details-row__value">
              {{ shipyardInternal.shipyardId }}
            </div>
          </div>
          <div class="details-row">
            <div class="details-row__title">Name</div>
            <div class="details-row__value">
              <editable-field
                fieldType="text"
                fieldName="shipyardName"
                :entityData="shipyardInternal"
                :saveMethod="updateShipyard"
                @updated="shipyardUpdated"
                @update-error="shipyardUpdateError"
                placeholder="--" />
            </div>
          </div>
        </CCol>
      </CRow>
    </div>

    <template #footer>
      <CButton @click="closeModal" color="secondary">Close</CButton>
    </template>
  </CModal>
</template>

<script>
import { mapActions } from 'vuex'
import EditableField from '../../widgets/EditableField'

export default {
  name: 'shipyard-edit-modal',
  components: {EditableField},
  props: {
    shipyard: {
      type: Object,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      shipyardInternal: null,
      errors: [],
    };
  },

  methods: {
    ...mapActions(
      'polygons', [
        'updateShipyard',
      ],
    ),

    shipyardUpdated(data) {
      this.shipyardInternal = data;
      this.$emit('updated', data);
    },

    shipyardUpdateError(response) {
      this.errors = [];
      if(response.error_details) {
        this.errors.push(response.error_details);
      } else {
        this.errors.push('Unknown shipyard update error');
      }
    },

    closeModal() {
      this.$emit('update:show', false);
    },
  },

  computed: {
    modalTitle() {
      if(this.shipyard) {
        return `Shipyard edit: "${this.shipyard.anchorageName}"`;
      } else {
        return `Shipyard edit`;
      }
    },
  },

  watch: {
    async show(value) {
      if(value) {
        this.shipyardInternal = this.shipyard;
      }
    },
  },
}
</script>

<style scoped>

</style>

<style scoped lang="scss">
  .content {
    padding: 0 10px;
  }

  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .fa-cog {
      color: #adadad;
    }
  }

  .details-row {
    padding-bottom: 5px;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dotted #c69b00;

    &__title {
      min-width: 50px;
      padding-right: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__value {
      padding-left: 10px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      /*direction: rtl;*/
      /*text-align: left;*/
    }
  }
</style>
